import React from "react"

const Squares = ({ width = "36", height = "36", viewBox = "0 0 36 36" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 20h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v16c0 1.1.9 2 2 2Zm0 16h12c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2H2c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2Zm20 0h12c1.1 0 2-.9 2-2V18c0-1.1-.9-2-2-2H22c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2ZM20 2v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2H22c-1.1 0-2 .9-2 2Z"
        fill="#DB1616"
      />
    </svg>
  )
}

export default Squares
